module.exports = __webpack_public_path__ + "img/mask.3a07ef30.png";